import * as React from 'react';

import { cn } from '../../lib/utils';

const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        'text-md placeholder:text-md file:text-foreground placeholder:text-[#A1A1A1] bg-[#F1F1F1] selection:bg-blue-200 selection:text-blue-900 dark:bg-input/30 dark:selection:bg-blue-800 dark:selection:text-blue-100 border-none flex h-4 w-full min-w-0 rounded-[8px] border px-4 py-6 shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
        'focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]',
        'aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive',
        className
      )}
      {...props}
    />
  );
});
Input.displayName = 'Input';

export { Input };
